import { render, staticRenderFns } from "./v2SearchPopup.vue?vue&type=template&id=a83ea394&scoped=true"
import script from "./v2SearchPopup.vue?vue&type=script&lang=ts"
export * from "./v2SearchPopup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a83ea394",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ChangePercent: require('/skade-pwa/components/ui/atom/ChangePercent.vue').default,Img: require('/skade-pwa/components/ui/atom/Img.vue').default})
